import { render, staticRenderFns } from "./chatInput.vue?vue&type=template&id=607d4b78&scoped=true"
import script from "./chatInput.vue?vue&type=script&lang=ts"
export * from "./chatInput.vue?vue&type=script&lang=ts"
import style0 from "./chatInput.vue?vue&type=style&index=0&id=607d4b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d4b78",
  null
  
)

export default component.exports